
import React, { useMemo, useRef, useContext } from 'react';
import { Decimal } from 'decimal.js';
import { Card, ListView, Flex } from 'antd-mobile';
import { Error, Loading } from '../../usms/components';
// import { formatBillUnit } from "../../../utils/utils";

import { timeFormatType, renderDate } from '../../usms/utils/timeFormat';
import { SmsTypeOfBillConfig } from '../utils/const';

import BasicContext from '../BasicContext';

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
});

const PricePoint = 4; // 价格小数点位数

export const convertPriceShow = (price, discount) => {
  return Decimal.mul(price, discount).div(10000).toFixed(PricePoint);
}

function DiscountList(props) {

  const context = useContext(BasicContext);
  const countryList = context.countryList || [];

  const { loading, errorMessage, list, billIdList } = props;
  const listRef = useRef()

  const dataSourceList = useMemo(() => dataSource.cloneWithRows(list), [list]);

  const renderPrice = (record) => {
    const MinPrice = convertPriceShow(record.Price, record.MinDiscount);
    const Price = convertPriceShow(record.Price, record.Discount);
    return `${MinPrice}/${Price}`;
  }

  const renderInnerPrice = record => {
    return convertPriceShow(record.Price, record.SettlementPriceDiscount);
  }

  const renderProductId = (record) => {
    const billId = billIdList.find((item) => item.ProductId === record.ProductId);
    const content = record.BillName || (billId && billId.BillName);
    return `${record.ProductId}(${content})`;
  }

  const renderCountry = BrevityCode => {
    const country = countryList.find(item => item.BrevityCode === BrevityCode)
    return country ? `${country.BrevityCode}-${country.NameCn}` : BrevityCode;
  }

  const row = (item) => {
    return <Card key={item.CompanyId} style={{ marginBottom: '10px' }}>
      <Card.Body style={{ paddingBottom: '10px' }}>
        <Flex className='flex'>
          <Flex.Item className='description-title'>Id</Flex.Item>
          <Flex.Item className='description-content'>{item.Id || item.ID || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>项目ID</Flex.Item>
          <Flex.Item className='description-content'>{item.AccountId || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>短信类型</Flex.Item>
          <Flex.Item className='description-content'>{SmsTypeOfBillConfig[item.Purpose] || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>国家/地区</Flex.Item>
          <Flex.Item className='description-content'>{renderCountry(item.BrevityCode) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>最低售价/实际售价(USD/条)</Flex.Item>
          <Flex.Item className='description-content'>{renderPrice(item)}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>内部结算价(USD/条)</Flex.Item>
          <Flex.Item className='description-content'>{renderInnerPrice(item)}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>计费ID</Flex.Item>
          <Flex.Item className='description-content'>{renderProductId(item)}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>生效时间</Flex.Item>
          <Flex.Item className='description-content'>{renderDate(item.ValidStartTime * 1000, timeFormatType.date)}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>结束时间</Flex.Item>
          <Flex.Item className='description-content'>{renderDate(item.ValidEndTime * 1000, timeFormatType.date)}</Flex.Item>
        </Flex>
        {/* <Flex className='flex'>
          <Flex.Item className='description-title'>操作人</Flex.Item>
          <Flex.Item className='description-content'>{item.Operator}</Flex.Item>
        </Flex> */}
      </Card.Body>
    </Card>
  }

  return (
    <Loading loading={loading} style={{ width: '100%' }}>
      {errorMessage ?
        <Error message={errorMessage} /> : <>
          <ListView
            ref={listRef}
            initialListSize={5}
            dataSource={dataSourceList}
            renderRow={row}
            style={{
              height: '400px',
              overflowY: 'auto'
            }}
            pageSize={5}
            scrollRenderAheadDistance={200}
          />
        </>
      }
    </Loading>
  )
}

export default DiscountList